var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocLeftIconActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 34,
    width: 38,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_9"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    stroke: "#000",
    id: "svg_3",
    height: 23,
    width: 7.692308,
    y: 4.526223,
    x: 1.868882,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000",
    transform: "rotate(90 29.185314178466797,16.066110610961918) ",
    id: "svg_4",
    height: 10,
    width: 23,
    y: 11.066108,
    x: 17.685314,
    fillOpacity: "null",
    strokeOpacity: "null",
    strokeWidth: 1.5,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000",
    transform: "rotate(90 16.870628356933594,16.0311393737793) ",
    id: "svg_7",
    height: 10,
    width: 23,
    y: 11.03114,
    x: 5.370629,
    fillOpacity: "null",
    strokeOpacity: "null",
    strokeWidth: 1.5,
    fill: "#000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocLeftIconActive);
export default __webpack_public_path__ + "static/media/docLeftIconActive.7b7f989a072177528fa0884669c5903e.svg";
export { ForwardRef as ReactComponent };